/**
 * Vault palette constants (exact hex from `main` branch `newPalette`).
 * Single source of truth for all Vault color values used in vaultColorOverrides.ts.
 * DO NOT modify — values must match main branch react-ts/src/theme/theme.ts newPalette.
 */

export const vaultNeutral = {
  N0: '#FFFFFF',
  N100: '#FAFBFF',
  N200: '#F2F2F3',
  N300: '#E4E5E6',
  N400: '#C6C8C9',
  N500: '#A2A6A8',
  N600: '#71717A',
  N700: '#546276',
  N800: '#17353D',
  N900: '#12292F',
  N1000: '#0A181B',
} as const;

// Vault navbar-specific colors not part of standard palette scales
export const vaultNavColors = {
  navActiveBg: '#1F4751', // manager nav open/active section background (from main branch NavLinkList)
} as const;

export const vaultTurquoise = {
  T100: '#D8EFEB',
  T200: '#81BBB1',
  T300: '#35A191',
  T400: '#168070',
  T500: '#096C5E',
} as const;

export const vaultGreen = {
  G100: '#BBDBC9',
  G200: '#A7ED24',
  G300: '#3EB572',
  G400: '#258750',
  G500: '#016533',
} as const;

export const vaultYellow = {
  Y100: '#FFF8F2',
  Y200: '#FFE3C7',
  Y300: '#FFC276',
  Y400: '#FFB020',
  Y500: '#A16F14',
} as const;

export const vaultRed = {
  R100: '#FCF2F2',
  R200: '#FF5F5F',
  R300: '#E2342A',
  R400: '#BE2714',
  R500: '#8F211B',
} as const;

/** Vault chart colors (main branch newPalette.chart, BEFORE Atlas migration) */
export const vaultChart = {
  blue: '#4B9BFF',
  yellow: '#FFB020',
  red: '#FF5F5F',
  green: '#45BF8C',
  pink: '#FF73C3',
  teal: '#74DDE5',
  violet: '#AF78FF',
  yellow2: '#FFD76E',
} as const;
